/*
 * @Author: huangzq
 * @Date: 2020-04-14 11:59:59
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-26 16:44:42
 * @Desc: 课程编辑里面的课件列表-展示添加的企业文件夹
*/
<template>
  <div class="course-list-material">
    <div
      v-if="!readonly"
      class="import-button"
      @click="handelOnImportBtnClick"
    >
      导入营销企业文件夹
    </div>

    <!-- 已导入的资料列表 -->
    <import-list
      :course-wares="courseWares"
      :readonly="readonly"
      @on-change="handelOnImportListChange"
    />

    <materials-dialog
      v-if="!readonly"
      :visible.sync="isShowMaterialsDialog"
      :choose-list="chooseList"
      :max-num="maxNum"
      @on-confirm="handelMaterialsDialogOnComfirm"
    />
  </div>
</template>

<script>
import ImportList from './import-list/index'
import MaterialsDialog from './materials-dialog'

export default {
  name: 'CourseListMaterial',
  components: { ImportList, MaterialsDialog },
  model: {
    prop: 'courseWares',
    event: 'change'
  },
  props: {
    courseWares: {
      type: Array,
      default () {
        return [{
          // 营销资料ID
          _id: '',
          // 课件名
          courseWareName: '',
          // 营销资料封面图片
          cover: '',
          // 文件类型,MaterialType是文件的时候才有
          fileType: '',
          // 文件oss地址链接
          url: '',
          // 标签ID
          tags: [],
          // 营销资料类型 文件、图片、视频，后续可添加案例库、宣传册等
          materialType: '',
          // 营销资料名字
          materialName: ''
        }]
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 其他接口promise：新建、更新、查询等
      api: {
        type: Object,
        default () {
          return {
            create: MKMATERIALSVC.VideoApi.videoCreatePost,
            update: MKMATERIALSVC.VideoApi.videoCreatePost,
            find: MKMATERIALSVC.VideoApi.videoDetailGet
          }
        }
      },

      // 是否显示企业文件夹关联弹窗
      isShowMaterialsDialog: false,

      // 课件最多可添加数量
      maxNum: 100

    }
  },
  computed: {
    chooseList () {
      return this.courseWares.map(item => item.materialId || item._id)
    }
  },

  methods: {
    // 导入按钮点击事件
    handelOnImportBtnClick () {
      if (this.courseWares.length >= this.maxNum) {
        this.$message.error(`课件内容最多可添加${this.maxNum}项`)
      } else {
        this.isShowMaterialsDialog = true
      }
    },

    // 课程操作事件更改
    handelOnImportListChange () {
      // this.$emit('change', courseWaresList)
    },

    // 导入弹窗确认事件
    handelMaterialsDialogOnComfirm (section) {
      const courseWaresList = section.map(item => {
        const courseItem = {
          // 营销资料ID
          materialId: item._id,
          // 课件名
          courseWareName: item.title,
          // 营销资料封面图片
          cover: item.cover,
          // 文件类型,MaterialType是文件的时候才有
          fileType: item.category === 3 ? item.fileType : 0,
          // 文件oss地址链接
          url: item.url,
          // 标签ID
          tags: item.tags || [],
          // 营销资料类型 文件、图片、视频，后续可添加案例库、宣传册等
          materialType: '' + item.category,
          // 营销资料名字
          materialName: item.title
        }
        return courseItem
      })
      const _data = [...this.courseWares, ...courseWaresList]
      this.$emit('change', _data)
      this.isShowMaterialsDialog = false
    }
  }
}
</script>

<style lang='scss' scoped>
.course-list-material {
  .import-button {
    width: 136px;
    height: 32px;
    margin-bottom: 15px;
    line-height: 32px;
    text-align: center;
    font-size: 13px;
    color: #009cff;
    border-radius: 4px;
    border: 1px solid #ccecff;

    @extend .cursor;
  }
}
</style>
